import pushNotificationSystemSubTypes from '../consts/notification/pushNotificationSystemSubTypes';
import pushNotificationTypes from '../consts/notification/pushNotificationTypes';

const getSystemSubTypes = () => Object.values(pushNotificationSystemSubTypes);

const pushNotificationConfig = {
    [pushNotificationTypes.FIRMWARE_UPDATE]: null,
    [pushNotificationTypes.LOYALTY]: null,
    [pushNotificationTypes.INFORMATIVE]: null,
    [pushNotificationTypes.MARKETING]: null,
    [pushNotificationTypes.CONVERSION]: null,
    [pushNotificationTypes.SYSTEM]: getSystemSubTypes(),
};

export default pushNotificationConfig;
